import React from 'react';
import ResponsiveNavbar from '../Components/Organisms/NavbarOrganism/ResponsiveNavbar';
import FooterContent from '../Components/Molecules/FooterMolecules/FooterContent';
import WhereToFindUs from '../Components/Organisms/WhereOrganism/WhereToFindUs';


const Maps = () => {
  return (
    <>
    <ResponsiveNavbar/>
    <WhereToFindUs/>
    <FooterContent/>
    </>
  )
}

export default Maps
